import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { bannerList } from "@/mocks/videos";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % bannerList.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goPrev = () =>
    setActive((prev) => (prev - 1 + bannerList.length) % bannerList.length);
  const goNext = () => setActive((prev) => (prev + 1) % bannerList.length);

  return (
    <section className="relative w-full overflow-hidden rounded-lg bg-foreground-950">
      <div className="relative h-[320px] w-full sm:h-[420px] lg:h-[520px]">
        {bannerList.map((banner, index) => (
          <Link
            key={banner.id}
            to={`/detail/${banner.id}`}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={banner.image}
              alt={`${banner.title} 焦点推荐`}
              title={`${banner.title} 在线播放`}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/10" />
          </Link>
        ))}

        <div className="absolute inset-0 flex items-end">
          <div className="mx-auto w-full max-w-[1280px] px-4 pb-12 md:px-6 md:pb-16">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-fill text-sm" />
                {bannerList[active].tag}
              </span>
              <h2 className="mt-4 text-2xl font-bold text-background-50 md:text-4xl font-heading">
                {bannerList[active].title}
              </h2>
              <p className="mt-3 line-clamp-2 text-sm text-background-200 md:text-base">
                {bannerList[active].subtitle}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${bannerList[active].id}`}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-fill text-lg" />
                  立即播放
                </Link>
                <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-medium text-background-50">
                  <i className="ri-information-line text-base" />
                  正版高清
                </span>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={goPrev}
          className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-foreground-950/40 text-background-50 transition-colors hover:bg-foreground-950/70 md:left-6 md:h-10 md:w-10"
        >
          <i className="ri-arrow-left-s-line text-xl" />
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={goNext}
          className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-foreground-950/40 text-background-50 transition-colors hover:bg-foreground-950/70 md:right-6 md:h-10 md:w-10"
        >
          <i className="ri-arrow-right-s-line text-xl" />
        </button>

        <div className="absolute bottom-5 right-4 flex items-center gap-2 md:right-6">
          {bannerList.map((banner, index) => (
            <button
              key={banner.id}
              type="button"
              aria-label={`切换到 ${banner.title}`}
              onClick={() => setActive(index)}
              className={`h-1.5 cursor-pointer rounded-full transition-all ${
                index === active ? "w-6 bg-primary-500" : "w-3 bg-background-50/60"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}